module.exports = __webpack_public_path__ + "img/EmojiObjectsOutlined.e67c01cd.svg";